<template>
  <div class="vacancy-result">
    <p>
      Поделитесь с нами, пожалуйста, как отработала эта вакансия. Удалось ли вам найти сотрудника?
    </p>
      <BasicForm
        ref="form"
        :action="action"
        @success="$emit('success', result)"
      >
        <input type="hidden" name="vacancyId" :value="vacancyId" />
        <div
          v-for="option in options"
          :key="option.value"
          class="vacancy-result__radio"
        >
          <FormField name="result">
            <BasicRadioButton
            
              v-model="result"
              :value="option.value"
              name="result"
            >
              {{ option.title }}
            </BasicRadioButton>
          </FormField>
        </div>
        <BasicButton
          type="submit"
          appearance="primary"
          size="m"
        >
          Сохранить результат
        </BasicButton>
    </BasicForm>
  </div>
</template>

<script>
import { VacanciesResultResource } from 'src/services/vacancies.js';

import BasicButton from 'src/components/BasicButton/BasicButton.vue';
import BasicForm from 'src/components/form/BasicForm/BasicForm.vue';
import BasicRadioButton from 'src/components/form/BasicRadioButton/BasicRadioButton.vue';
import FormField from 'src/components/form/FormField/FormField.vue';

export default {
  name: 'VacancyResultForm',

  components: {
    BasicForm,
    BasicRadioButton, 
    BasicButton,
    FormField,
  },
  props: {
    vacancyResult: {
      type: Object,
      required: true,
    },
    vacancyId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      result: null,
    };
  },

  methods: {
    action: VacanciesResultResource.post,
  },

  computed: {
    options() {
      if (!this.vacancyResult.meta) return [];
      return Object.entries(this.vacancyResult.meta).map(([ key, val ]) => ({
        value: key,
        title: val,
      }));
    },
  },
}

</script>